import { motion } from "framer-motion";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
    {
        q: "What are your clinic hours?",
        a: "Mirrari Clinic is open every day from 11:00 AM to 9:00 PM. Appointments are strongly recommended.",
    },
    {
        q: "How do I book an appointment?",
        a: "You can book instantly on WhatsApp at +91 7808407407, or call us directly during clinic hours. You can also email us and we'll confirm your slot.",
    },
    {
        q: "Do you offer PRP for hair and skin?",
        a: "Yes. Dr. Hitesh Khatri offers medical-grade PRP for hair thinning and skin rejuvenation, after a detailed consultation and diagnostic workup.",
    },
    {
        q: "Is root canal treatment painful?",
        a: "Modern endodontics is virtually painless. Dr. Chitra Sachdev uses refined anaesthesia protocols so most patients report only mild discomfort that resolves within a day.",
    },
    {
        q: "What dermatology concerns do you treat?",
        a: "Acne, scars, pigmentation, melasma, hair fall, PRP, skin analysis, venereology and leprosy care, plus routine dermatology consultations.",
    },
    {
        q: "Do you accept walk-ins?",
        a: "We do our best to accommodate walk-ins, but appointment holders are seen first. Please call ahead whenever possible.",
    },
];

export default function FAQ() {
    return (
        <section
            id="faq"
            className="py-24 md:py-32 bg-[#F3F1EC]/60"
            data-testid="faq-section"
        >
            <div className="max-w-5xl mx-auto px-6 md:px-12">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 0.6 }}
                    className="text-center max-w-3xl mx-auto"
                >
                    <span className="text-xs uppercase tracking-[0.3em] text-[#8A9A5B] font-medium">
                        — Frequently Asked
                    </span>
                    <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-light text-[#1A221F] mt-4 leading-[1.1] tracking-tight">
                        Questions, <em className="italic text-[#3B5249]">answered.</em>
                    </h2>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.6, delay: 0.1 }}
                    className="mt-12"
                >
                    <Accordion
                        type="single"
                        collapsible
                        className="w-full bg-white rounded-[2rem] border border-[#E8E6E1] px-6 md:px-10 py-2 shadow-[0_8px_30px_rgba(0,0,0,0.04)]"
                    >
                        {faqs.map((f, i) => (
                            <AccordionItem
                                key={i}
                                value={`item-${i}`}
                                className="border-b border-[#E8E6E1] last:border-0"
                                data-testid={`faq-item-${i}`}
                            >
                                <AccordionTrigger
                                    className="text-left font-display text-lg md:text-xl text-[#1A221F] hover:text-[#3B5249] hover:no-underline py-6"
                                    data-testid={`faq-trigger-${i}`}
                                >
                                    {f.q}
                                </AccordionTrigger>
                                <AccordionContent className="text-[#4A5D54] text-base leading-relaxed pb-6">
                                    {f.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </motion.div>
            </div>
        </section>
    );
}
